.WarningIcon {
    font-size: 24px;
    color: rgb(234 179 8);
    ;
}

.WarningText {
    font-weight: 500;
}
